export default __webpack_public_path__ + "finale.d1704c7a.png";